import jsPDF from "jspdf";
import logoGente from "../../../src/imagens/20191205 - Logo GENTE.png";
import logoPrefeitura from "../../../src/imagens/prefeitura_ouro_preto_logo_1.png";
import Api from "../../services/Api";

class PdfEducation {
  static async gerarRelatorio(
    distrito,
    educationMapImage,
    nivelEscolaridade,
    matriculaEscola,
    qualidadeEscolasRurais,
    nivelEscolaridadeImage,
    matriculaEscolaImage,
    qualidadeEscolasRuraisImage,
  ) {
    const [
      propriedades,
      areaMedia,
      nivelEscolaridadeData,
      matriculaEscolaData,
      qualidadeEscolasRuraisData,
    ] = await Promise.all([
      Api.getNumeroPropriedadesEducacao(
        distrito,
        nivelEscolaridade,
        matriculaEscola,
        qualidadeEscolasRurais,
      ),
      Api.getAreaMediaDistritoEducacao(
        distrito,
        nivelEscolaridade,
        matriculaEscola,
        qualidadeEscolasRurais,
      ),
      Api.getNivelEscolaridade(
        distrito,
        null,
        matriculaEscola,
        qualidadeEscolasRurais,
      ),
      Api.getMatriculaEscola(
        distrito,
        nivelEscolaridade,
        null,
        qualidadeEscolasRurais,
      ),
      Api.getQualidadeEscolasRurais(
        distrito,
        nivelEscolaridade,
        matriculaEscola,
        null,
      ),
    ]);

    const doc = new jsPDF();
    const imgSize = 64;

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageOne(
      doc,
      distrito,
      propriedades.value,
      areaMedia.value,
      nivelEscolaridade,
      matriculaEscola,
      qualidadeEscolasRurais,
      educationMapImage,
    );

    doc.addPage();

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageTwo(
      doc,
      propriedades.value,
      nivelEscolaridadeData.value,
      matriculaEscolaData.value,
      qualidadeEscolasRuraisData.value,
      nivelEscolaridadeImage,
      matriculaEscolaImage,
      qualidadeEscolasRuraisImage,
      imgSize,
    );

    const fileName =
      "Relatorio_Educacao_" + distrito + "_" + this.dataAtual() + ".pdf";
    doc.save(fileName);
  }

  static pageOne(
    doc,
    distrito,
    propriedades,
    areaMedia,
    nivelEscolaridade,
    matriculaEscola,
    qualidadeEscolasRurais,
    educationMapImage,
  ) {
    // Considerações Iniciais
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Considerações iniciais", 10, 40);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    const consideracoes = `      As informações e dados contidas no presente relatório foram extraídas através do dashboard oficial do Censo Agropecuário de Ouro Preto – MG. O Censo Agropecuário foi uma das principais etapas do Plano Municipal de Desenvolvimento Rural de Ouro Preto, projeto desenvolvido pela Secretaria Municipal de Agropecuária em parceria com a Universidade Federal de Viçosa. O objetivo central do Censo Agropecuário consistiu na busca de informações sobre os estabelecimentos e as atividades agropecuárias, caracterizando o produtor e o estabelecimento, a economia e emprego no meio rural, a pecuária, a lavoura e a agroindústria. Todo o processo foi realizado a partir da aplicação do Boletim de Cadastro Rural (BCR), formulário estruturado para caracterizar as propriedades, a infraestrutura rural, as condições socioeconômicas dos produtores e as atividades desenvolvidas. A seguir serão sintetizados alguns dados do Censo Agropecuário em formas de tabelas, gráficos e mapas.`;
    doc.text(consideracoes, 10, 50, { maxWidth: 180, align: "justify" });

    // Lista de condições e filtros
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Lista de condições e filtros aplicados", 10, 110);

    let y = 120;
    const filtros = [
      ["Distrito:", distrito || "Não informado"],
      ["Nível de escolaridade: ", nivelEscolaridade || "-"],
      ["Matrícula em escola: ", matriculaEscola || "-"],
      ["Qualidade das escolas rurais: ", qualidadeEscolasRurais || "-"],
    ];

    doc.setFontSize(12);

    filtros.forEach(([label, valor]) => {
      // Marcador
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      // Label em negrito
      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 5, y);

      y += 6;
    });

    y += 5;
    // Indicadores
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Informações Gerais", 10, y);
    y += 10;

    const indicadores = [["Propriedades:   ", propriedades], ["Área média:   ", areaMedia.toFixed(2)]];

    doc.setFontSize(12);

    indicadores.forEach(([label, valor]) => {
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 2, y);

      y += 6;
    });

    y += 5;

    doc.addImage(educationMapImage, "PNG", 20, y, 100, 80); // aumenta um pouco pra ver
  }

  static pageTwo(
    doc,
    propriedades,
    nivelEscolaridadeData,
    matriculaEscolaData,
    qualidadeEscolasRuraisData,
    nivelEscolaridadeImage,
    matriculaEscolaImage,
    qualidadeEscolasRuraisImage,
    imgSize,
  ) {
    let y = 40;

    doc.addImage(
      nivelEscolaridadeImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      ${this.calcPercentual(nivelEscolaridadeData["01 - Ensino Infantil"], propriedades)}% dos entrevistados indicam ter ensino infantil, enquanto ${this.calcPercentual(nivelEscolaridadeData["02 - Ensino Fundamental"], propriedades)}% indicam ter ensino fundamental, ${this.calcPercentual(nivelEscolaridadeData["03 - Ensino Médio"], propriedades)}% indicam ter ensino médio e ${this.calcPercentual(nivelEscolaridadeData["04 - Ensino Superior"], propriedades)}% indicam ter ensino superior.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    y += 5;

    doc.addImage(
      matriculaEscolaImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      Observa-se que ${this.calcPercentual(matriculaEscolaData["01 - Não"], propriedades)}% dos entrevistados declararam não estar matriculados em escola, enquanto ${this.calcPercentual(matriculaEscolaData["02 - Sim"], propriedades)}% afirmaram estar matriculados, e ${this.calcPercentual(matriculaEscolaData["Não Informado"], propriedades)}% não apresentaram informação.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    y += 5;

    doc.addImage(
      qualidadeEscolasRuraisImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      Constata-se que ${this.calcPercentual(qualidadeEscolasRuraisData["01 - Não Há Escola Rural"], propriedades)}% dos entrevistados informaram não haver escola rural na comunidade, enquanto ${this.calcPercentual(qualidadeEscolasRuraisData["02 - Ruim"], propriedades)}% avaliaram a estrutura como ruim. Além disso, ${this.calcPercentual(qualidadeEscolasRuraisData["03 - Regular"], propriedades)}% classificaram as escolas como regular, ${this.calcPercentual(qualidadeEscolasRuraisData["04 - Bom"], propriedades)}% apontaram como boas, e ${this.calcPercentual(qualidadeEscolasRuraisData["05 - Ótimo"], propriedades)}% as consideraram ótimas. Por fim, ${this.calcPercentual(qualidadeEscolasRuraisData["Não Informado"], propriedades)}% não apresentaram informação.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
  }

  static calcPercentual(val, total) {
    const res = (val / total) * 100;
    return res.toFixed(2);
  }

  static gerarCabecalho(doc, logoEsq, logoDir) {
    // Logo à esquerda
    if (logoEsq) {
      doc.addImage(logoEsq, "PNG", 10, 10, 30, 20);
    }

    // Logo à direita
    if (logoDir) {
      doc.addImage(logoDir, "PNG", 170, 10, 30, 15);
    }

    // Título central
    doc.setFontSize(14);
    doc.text(
      "Relatório de educação das propriedades rurais",
      doc.internal.pageSize.getWidth() / 2,
      15,
      { align: "center" },
    );
    doc.text(
      "cadastradas no censo agropecuário",
      doc.internal.pageSize.getWidth() / 2,
      21,
      { align: "center" },
    );

    // Informações extras
    doc.setFontSize(8);
    doc.text(`Data: ${new Date().toLocaleDateString()}`, 170, 28);

    // Linha divisória
    doc.setDrawColor(150);
    doc.line(10, 32, 200, 32);
  }

  static dataAtual() {
    const hoje = new Date();

    const data = hoje.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const formatada = data.replace(/\//g, "_");

    return formatada;
  }
}

export default PdfEducation;
